'use client';

import { c as _c } from "react/compiler-runtime";
import { Tab } from '@common/components';
import { Suspense, useEffect, useRef, useState } from 'react';
import { useScrollToSection } from '@/app/donation/_hooks/useScrollToSection';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { TABS, TABS_LABELS } from '../constants';
import type { Tab as TabType } from '../types';
interface MarketDetailTabProps {
  className?: string;
}
const MOBILE_STICKY_OFFSET = 48;
const DESKTOP_STICKY_OFFSET = 72;
const MarketDetailTabComponent = t0 => {
  const $ = _c(11);
  const {
    className
  } = t0;
  const [tab, setTab] = useState(TABS.BASIC);
  const isUserScrolling = useRef(true);
  const isMobileTablet = useMediaQuery(BREAKPOINTS.MOBILE_TABLET, false);
  const {
    scrollToSectionWithTab
  } = useScrollToSection();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const tabIds = Object.values(TABS);
      const observer = new IntersectionObserver(entries => {
        if (!isUserScrolling.current) {
          return;
        }
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const activeId = tabIds.find(id => id === entry.target.id);
            if (activeId) {
              setTab(activeId as TabType);
            }
          }
        }
      }, {
        rootMargin: "0px 0px -50% 0px",
        threshold: 0
      });
      tabIds.forEach(id_0 => {
        const element = document.getElementById(id_0);
        if (element) {
          observer.observe(element);
        }
      });
      return () => observer.disconnect();
    };
    t2 = [TABS];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = isMobileTablet ? "sm" : "lg";
  let t4;
  if ($[2] !== isMobileTablet || $[3] !== scrollToSectionWithTab) {
    t4 = value => {
      isUserScrolling.current = false;
      setTab(value as TabType);
      scrollToSectionWithTab(value, {
        offset: isMobileTablet ? MOBILE_STICKY_OFFSET : DESKTOP_STICKY_OFFSET
      });
      setTimeout(() => {
        isUserScrolling.current = true;
      }, 1000);
    };
    $[2] = isMobileTablet;
    $[3] = scrollToSectionWithTab;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Object.values(TABS).map(_temp);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== className || $[7] !== t3 || $[8] !== t4 || $[9] !== tab) {
    t6 = <Tab size={t3} className={className} variant="full" value={tab} onChange={t4}>{t5}</Tab>;
    $[6] = className;
    $[7] = t3;
    $[8] = t4;
    $[9] = tab;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export const MarketDetailTab = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Suspense><MarketDetailTabComponent {...props} /></Suspense>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(tabValue) {
  return <Tab.Item key={tabValue} value={tabValue}>{TABS_LABELS[tabValue]}</Tab.Item>;
}